const certificados = [
    { nombre : "Full Stack ITBA",
        imagen : "/docs/cert_image/ITBA_FullStack.png"
    },
    { nombre : "Programador",
        imagen : "/docs/cert_image/programadoranual.jpg"
    },
    { nombre : "Python Unahur",
        imagen : "/docs/cert_image/Python_Unahur.jpg"
    },
    { nombre : "IA Big",
        imagen : "/docs/cert_image/DesarrolloConIA.jpg"
    },
    { nombre : "HTML SoloLearns",
        imagen : "/docs/cert_image/SoloLearns_HTML.jpeg"
    },
    { nombre : "SQL SoloLearns",
        imagen : "/docs/cert_image/SoloLearns_JAVA.jpeg"
    },
    { nombre : "JavaScript SoloLearns",
        imagen : "/docs/cert_image/SoloLearns_SQL.jpeg"
    },
    { nombre : "Python Santander",
        imagen : "/docs/cert_image/PythonSantander.jpg"
    },
]
export default certificados;